export default {
	title: "Reports",
	selectReport: "Select a report to view",
	ritualReport: "Ritual Report",
	noClosedRituals: "No closed rituals found",
	requiresClosed: "The ritual must be closed to access the report.",
	closings: {
		title: "Ritual Closings",
		description: "Detailed reports of closed rituals",
		totalClosed: "Closed rituals",
	},
	print: "Print",
	sendEmail: "Send by email",
	emailSent: "Report sent to your email",
	emailError: "Error sending report by email",
	printHeader: {
		printedAt: "Printed at",
	},
	back: "Back",
	header: {
		type: "Type",
		spiritualLine: "Spiritual Line",
		date: "Date",
		location: "Location",
		openedBy: "Opened by",
		closedBy: "Closed by",
	},
	stats: {
		title: "Statistics",
		ritualDuration: "Ritual Duration",
		attendanceDuration: "Attendance Duration",
		firstCall: "First Call",
		lastCall: "Last Call",
		avgIncremental: "Avg Time (On Demand)",
		avgPreDefined: "Avg Time (Fixed)",
		totalTickets: "Total Tickets",
		cancelledTickets: "Cancelled",
		newPersons: "New Persons",
		minutes: "min",
		notAvailable: "N/A",
	},
	tickets: {
		title: "Attendance Tickets",
		code: "Ticket",
		person: "Person",
		createdAt: "Created",
		calledAt: "Called",
		finishedAt: "Finished",
		elapsed: "Duration",
		status: "Status",
		medium: "Medium",
		guide: "Guide",
		avgTime: "Avg time",
		noTickets: "No tickets in this group",
	},
	messages: {
		title: "Messages",
		type: "Type",
		severity: "Severity",
		message: "Message",
		person: "Person",
		createdBy: "Created by",
	},
	returns: {
		fulfilledTitle: "Returns Fulfilled in this Ritual",
		newTitle: "New Returns",
		returnType: "Type",
		person: "Person",
		target: "Target",
		status: "Status",
		notes: "Notes",
		fulfilled: "Fulfilled",
		pending: "Pending",
	},
	general: {
		title: "General Rituals Report",
		menuTitle: "General Report",
		fetchError: "Error loading report",
		exportPdf: "Export PDF",
		pdfError: "Error generating PDF",
		minutesShort: "min",
		filters: {
			status: "Status",
			allPeriods: "All time",
		},
		empty: {
			title: "No rituals in the period",
			description: "Adjust the period or the selected statuses to see results.",
		},
		groups: {
			byRitual: "Ritual overview",
			byType: "Distribution by type",
			mediums: "Medium performance",
		},
		kpis: {
			rituals: "Rituals",
			completedTickets: "Attendances",
			distinctPersons: "People attended",
			cancelledTickets: "Cancelled tickets",
			totalTime: "Total time",
			avgTime: "Average time",
		},
		charts: {
			ticketsByRitual: "Attendances per ritual",
			ticketsByRitualType: "Attendances per ritual type",
			avgByRitualType: "Average attendances per ritual type",
			ticketDistribution: "Ticket distribution",
			topMediumsByTime: "Mediums with the most attendance time",
			topMediumsByAvg: "Mediums with the highest average attendances",
			attendances: "Attendances",
			avgAttendances: "Average attendances",
			attendancesShort: "att.",
			tickets: "tickets",
			completed: "Completed",
			notCompleted: "Not completed",
			cancelled: "Cancelled",
			totalTime: "Total time",
		},
		byMedium: {
			title: "By medium",
			medium: "Medium",
			attendances: "Attendances",
			rituals: "Rituals",
			totalTime: "Total time",
			avgTime: "Average time",
			empty: "No medium with attendances in the period",
		},
		byGuide: {
			title: "By guide",
			guide: "Guide",
			medium: "Medium",
			attendances: "Attendances",
			totalTime: "Total time",
			avgTime: "Average time",
			empty: "No guide with attendances in the period",
		},
	},
};
